export class ApprovalClinic {
    constructor(init) {
        Object.assign(this, init);
    }
}
export class BillingCreditCard {
    constructor(init) {
        Object.assign(this, init);
    }
}
export class SaveJobOffer {
    constructor(init) {
        Object.assign(this, init);
    }
}
export class Receipt {
}
export class Receipts {
}
export class ContractRenewal {
}
